module.exports = __webpack_public_path__ + "static/ItMan-043e73e50c26488fcd13288b7d182d32.svg";